<script>
  import {link} from 'svelte-spa-router'
	import {Table,Styles} from 'sveltestrap';
	import {searchNinja} from './NinjaAPI.svelte' 
	export let params = {}
	let ninjas =[]
  $: console.log(params.text)
	$: ninjas = searchNinja(params.text)
</script>
<h1>Search</h1>
<Table>
  <thead>
    <tr>
      <th>ID</th>
      <th>Name</th>
      <th>Photo</th>
    </tr>
  </thead>
  <tbody>
    {#each ninjas as ninja}
    <tr>
      <td><a href="/{ninja.id}" use:link>{ninja.alt}</a></td>
      <td>{ninja.name}</td>
      <td>
        <img src="{ninja.img}" height="30" alt="{ninja.id}">
      </td>
    </tr>
    {/each}
  </tbody>
</Table>




  



<Styles/>